module.exports = __webpack_public_path__ + "1.5.0-unryo/img/couchbase.bb5e9f56.svg";